import { render, staticRenderFns } from "./InformesFiscais.vue?vue&type=template&id=51c78176"
import script from "./InformesFiscais.vue?vue&type=script&lang=js"
export * from "./InformesFiscais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports